const BlogData = [
    {
        id: "1",
        img: "https://ik.imagekit.io/dqe4fvjcky/WhatsApp_Image_2023-01-11_at_7.50.11_PM_7vl2NYuGq.jpeg?ik-sdk-version=javascript-1.4.3&updatedAt=1673453235241",
        title: "Recovery Is Easier Than Healing"
    },
    {
        id: "2",
        img: "https://ik.imagekit.io/dqe4fvjcky/_BeStreetSmart_o7Um6yYTu.png?ik-sdk-version=javascript-1.4.3&updatedAt=1673944410371",
        title: "Redefining What It Means To #BeStreetSmart",
    },
    {
        id: "3",
        img: "https://ik.imagekit.io/dqe4fvjcky/blog_No_5-min_OAL-veXi5X.png?ik-sdk-version=javascript-1.4.3&updatedAt=1676028601532",
        title: "Sustainable Mobility for India: The G20 Vision"
    },
    {
        id: "4",
        img: "https://ik.imagekit.io/dqe4fvjcky/jpg_20230314_135602_0000-min_vAwM6ZbTf.jpg?updatedAt=1678805290205",
        title: "Why We Need Inclusive Transportation"
    }
]



export default BlogData;